export default __webpack_public_path__ + "static/media/error.f367ac8c.png";